/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Helmet} from 'react-helmet'
import {Link} from 'react-router-dom'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import Loader from '../loaders/loader'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {orderInfo, productShop} from '../../lib/path'

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

export default class AddRecordInternal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeWarehouseId: null,
      refWarehouseId: null,
      createMin: null,
      createMax: null,
      date: null,
      warehouseIds: [],
      refWarehouseIds: [],
      manualRegisterDate: null,
      results: [],
      docTypes: [],
      doctTypeId: '',
      selectedDate: null,
      incompatibleRemainProducts: [],
      incompatibleSupplyOrderProducts: [],
      incompatibleDispatchProducts: [],
      unMatchProduct: [],
      detailsItem: [],
      providers: [],
      sellerId: null,
      preDocId: this.props.match.params.preDocId,
      preDocInfo: {
        typeWarehouseName: null,
        refTypeWarehouseName: null,
        registerPerson: null,
        registerDate: null,
        senderName: null,
        refFactorNo: null,
        refFactorDate: null,
        providerName: null,
        providerId: null,
        isInternal: null,
        isInput: null,
        automatic: null,
        receiverName: null,
        manualRegisterDate: null,
        manualReg: null,
        detailEntities: []
      },
      detailEntities: []
    }
  }

  componentDidMount() {
    this.init()
  }

  init = () => {
    let {preDocId} = this.props.match.params
    this.setState({
      loading: true
    })
    Promise.all([this.getPreRecord(preDocId)])
      .then((res) => {
        this.getDepot().then((result) => {
          this.setState({
            confirmation: false
          })
          let products = res[0].detailEntities
          let depots = result === null || result === '' ? [] : result
          products.forEach((item) => {
            if (depots.length) {
              let findDepots = depots.find((ch) => ch.productArticleId === item.stockProductId)
              if (findDepots) {
                item.detailsProduct = findDepots.details
                // item.sumPackageQuantity = findDepots.sumPackageQuantity
                item.sumQuantity = findDepots.sumQuantity
                if (findDepots.sumQuantity === item.quantity) {
                  item.expanded = false
                  item.selected = true
                  item.detailsProduct.forEach((d) => {
                    d.selected = true
                  })
                } else {
                  item.expanded = true
                  item.selected = false
                  item.detailsProduct.forEach((d) => {
                    d.selected = false
                  })
                }
              } else {
                item.detailsProduct = []
              }
            }
            item.selectedProductCount = this.toFixedVal(this.calcSum(item.detailsProduct))
          })
          this.setState({
            loading: false
          })
        })
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  calcSum = (detailsProduct) => {
    let sum = 0
    if (detailsProduct) {
      return detailsProduct
        .filter((i) => i.selected)
        .reduce(function(acc, current) {
          // return Number(acc) + Number(current.packageQuantity)
          return Number(acc) + Number(current.quantity)
        }, sum)
    } else {
      return 0
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getPreRecord = (docId) => {
    let data = {
      docId
    }
    return http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUMENT_GET_PREVIEW}`, data, {})
      .then((res) => {
        if (res.data.error === null) {
          let result = res.data.object
          this.setState({
            preDocInfo: {
              typeWarehouseName: result.typeWarehouseName,
              refTypeWarehouseName: result.refTypeWarehouseName,
              registerPerson: result.registerPerson,
              registerDate:
                result.registerDate === null ? '' : jMoment(result.registerDate).format('jYYYY/jM/jD HH:mm'),
              senderName: result.senderName,
              receiverName: result.receiverName,
              refFactorNo: result.refFactorNo,
              refFactorDate: result.refFactorDate === null ? '' : jMoment(result.refFactorDate).format('jYYYY/jM/jD'),
              providerName: result.providerName,
              providerId: result.providerId,
              isInternal: result.isInternal,
              isInput: result.isInput,
              automatic: result.automatic,
              manualRegisterDate:
                result.manualRegisterDate === null ? '' : jMoment(result.manualRegisterDate).format('jYYYY/jM/jD'),
              manualReg: result.manualRegisterDate,
              detailEntities: result.detailEntities
            },
            detailEntities: result.detailEntities
          })
          return res.data.object
        }
      })
      .catch((err) => {
        return Promise.reject('خطا در دریافت اطلاعات پیش سند')
      })
  }

  convertToStringDate = (date, type) => {
    // console.log('start: ' ,moment(1615680000000).startOf('day').toISOString())
    // console.log('end: ', moment(1615680000000).endOf('day').toISOString())
    if (type === 'from') {
      let from = moment(date)
        .startOf('day')
        .toISOString()
      return from
    } else {
      let to = moment(date)
        .endOf('day')
        .toISOString()
      return to
    }
    // new Date('').toISOString()
  }

  jalaliDate = (date) => {
    if (date === null) {
      return ''
    } else {
      return this.convertDigit(jMoment(date).format('jYYYY/jM/jD'))
    }
  }

  getDepot = () => {
    let {preDocInfo} = this.state
    let manualRegisterDate = preDocInfo.manualReg
    let params = {
      deliveryDateMin: this.convertToStringDate(manualRegisterDate, 'from'),
      deliveryDateMax: this.convertToStringDate(manualRegisterDate, 'to')
    }
    return http
      .get(`warehouse/depot/orders/items`, {
        params
      })
      .then((res) => {
        if (res.data.error === null) {
          let results = res.data.object
          this.setState({
            results,
            showTable: true
          })
          return results
        } else {
          this.setState({
            results: [],
            showTable: false
          })
          return []
        }
      })
      .catch(() => {})
  }

  toggleExpand = (item) => {
    item.expanded = !item.expanded
    let {preDocInfo} = this.state
    let detailEntities = this.state.detailEntities

    this.setState({
      detailEntities
    })
  }

  changeItemFromChild = (ch, parent) => {
    let {preDocInfo} = this.state
    let detailEntities = this.state.detailEntities
    let selectedProductCount = parent.selectedProductCount
    ch.selected = !ch.selected
    this.setState(
      {
        detailEntities
      },
      () => {
        let selectedDetailsProduct = parent.detailsProduct.filter((i) => i.selected)
        parent.selectedProductCount = this.toFixedVal(this.calcSum(selectedDetailsProduct))
        let checkEveryChild = parent.detailsProduct.every((i) => i.selected)
        if (checkEveryChild) {
          parent.selected = true
          parent.indeterminate = false
        } else {
          parent.selected = false
          let findLeastOneSelected = parent.detailsProduct.find((i) => i.selected)
          if (findLeastOneSelected) {
            parent.indeterminate = true
          } else {
            parent.indeterminate = false
          }
        }
        if (parent.quantity >= parent.selectedProductCount) {
          this.setState({
            detailEntities
          })
        } else {
          parent.selected = false
          ch.selected = false
          let selectedDetailsProduct = parent.detailsProduct.filter((i) => i.selected)
          parent.selectedProductCount = this.toFixedVal(this.calcSum(selectedDetailsProduct))
          let findLeastOneSelected = parent.detailsProduct.find((i) => i.selected)
          if (findLeastOneSelected) {
            parent.indeterminate = true
          } else {
            parent.indeterminate = false
          }
          this.setState(
            {
              detailEntities
            },
            () => {
              message.error(`تعداد در پیش سند ${parent.quantity} میباشد . نمیتوانید بیشتر از آن انتخاب کنید . `)
            }
          )
        }
      }
    )
  }

  checkParentCount = (parent, type) => {
    let sum = 0
    if (type === 'child') {
      let sumSelectedTemporary = parent.detailsProduct
        .filter((i) => i.selected)
        .reduce(function(acc, current) {
          return Number(acc) + Number(current.quantity)
        }, sum)
      return sumSelectedTemporary
    } else if (type === 'parent') {
      let sumSelectedTemporary = parent.detailsProduct.reduce(function(acc, current) {
        return Number(acc) + Number(current.quantity)
      }, sum)
      return sumSelectedTemporary
    }
  }

  changeSelectFromParrent = (parent) => {
    if (parent.detailsProduct.length) {
      let {preDocInfo} = this.state
      let detailEntities = this.state.detailEntities
      if (parent.selected) {
        parent.selected = false
        parent.indeterminate = false
        parent.selectedProductCount = 0
        parent.detailsProduct.forEach((item) => {
          item.selected = false
        })
        this.setState({
          detailEntities
        })
      } else {
        let sumOfChild = this.checkParentCount(parent, 'parent')
        if (sumOfChild <= parent.quantity) {
          parent.detailsProduct.forEach((item) => {
            item.selected = true
          })
          parent.selected = true
          parent.indeterminate = false
          parent.selectedProductCount = this.toFixedVal(sumOfChild)
          this.setState({
            detailEntities
          })
        } else {
          message.error(`تعداد در پیش سند ${parent.quantity} میباشد . نمیتوانید بیشتر از آن انتخاب کنید . `)
        }
      }
    } else {
      message.error(`هیچ سفارشی از محصول ${parent.productName} ثبت نشده است`)
    }
  }

  checkDisableButton = () => {
    let {preDocInfo} = this.state
    let detailEntities = this.state.detailEntities

    let checkEverySelected = detailEntities.every((i) => {
      return this.toFixedVal(i.selectedProductCount) === this.toFixedVal(i.quantity)
    })
    return checkEverySelected
  }

  selectItem = (item, e) => {
    e.stopPropagation()
    item.selected = !item.selected
    this.setState({
      results: this.state.results
    })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x, 'jYYYY/jM/jD').format('jYYYY/jM/jD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x, 'jYYYY/jM/jD').format('jYYYY/jM/jD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  checkFields = () => {
    this.setState({
      confirmation: true
    })
  }

  createRecord = () => {
    let detailEntities = this.state.detailEntities
    let {preDocId} = this.props.match.params
    let array = []
    detailEntities.forEach((item) => {
      item.detailsProduct.forEach((ch) => {
        if (ch.selected) {
          array.push({
            id: ch.id,
            quantity: ch.quantity,
            productArticleId: ch.productArticleId
          })
        }
      })
    })
    let model = {
      preWarehouseDocId: +preDocId,
      productStockTransactions: array
    }
    this.setState({
      loading: true
    })
    http
      .post(`warehouse/depot/document/record`, model, {})
      .then((res) => {
        this.setState({loading: false})
        if (res.data.error === null) {
          message.success('سند با موفقیت ثبت شد')
          setTimeout(() => {
            window.location.assign('/Record')
          }, 2000)
        } else {
          this.init()
          message.error(res.data.description)
          if (res.data.object.incompatible) {
            this.setState({
              modalShowUnmatch: true,
              confirmation: false,
              incompatibleRemainProducts: res.data.object.incompatibleRemainProducts
            })
          }
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  showDetailsItem = (item) => {
    this.setState({
      detailsItem: item.details,
      detailsModal: true,
      selectedProductName: item.productTitle
    })
  }

  showUnitOfProduct = (item) => {
    if (item.productUnitId === item.productPackageUnitId) {
      return item.sumQuantity + ' ' + item.productUnitTitle
    } else {
      return (
        item.sumPackageQuantity +
        '  ' +
        item.productPackageUnitTitle +
        ' ( ' +
        ' معادل  ' +
        item.sumQuantity +
        '  ' +
        item.productUnitTitle +
        ' ) '
      )
    }
  }

  toFixedVal = (val) => {
    if (val === 0) return 0
    else if (val === '' || val === null || !val) return 0
    else return +val.toFixed(3)
  }

  render() {
    let {preDocInfo} = this.state
    return (
      <div>
        {!this.state.confirmation && <Loader show={this.state.loading} />}
        <Helmet>
          <meta charSet="utf-8" />
          <title>افزودن سند بین انباری دپو به چیدمان</title>
        </Helmet>
        <div className="container-fluid">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>افزودن سند بین انباری دپو به چیدمان</li>
          </ul>
          <div className="bg-white my-3 p-3">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <span className="font-weight-bold">اطلاعات پیش سند شماره : {this.state.preDocId}</span>
                  </div>
                  <div className="card-body">
                    {/*<i className='fas fa-caret-down'></i>*/}
                    <div className="row">
                      <div className="col-auto my-1">
                        <span className="">انبار مبدا : </span>
                        <span className="font-weight-bold">{preDocInfo.typeWarehouseName}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">انبار مقصد : </span>
                        <span className="font-weight-bold">{preDocInfo.refTypeWarehouseName}</span>
                      </div>
                      {/* <div className='col-auto my-1'>
                                                <span className=''>پیش سند وارده : </span>
                                                {preDocInfo.isInput ?
                                                    <i className='fas fa-check text-success align-middle'></i>
                                                    :
                                                    <i className='fas fa-times text-danger align-middle'></i>
                                                }
                                            </div> */}
                      <div className="col-auto my-1">
                        <span className="">پیش سند بین انباری : </span>
                        {preDocInfo.isInternal ? (
                          <i className="fas fa-check text-success align-middle" />
                        ) : (
                          <i className="fas fa-times text-danger align-middle" />
                        )}
                      </div>
                      <div className="col-auto my-1">
                        <span className="">کاربر ثبت کننده : </span>
                        <span className="font-weight-bold">{preDocInfo.registerPerson}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">تاریخ ثبت پیش سند : </span>
                        <span className="font-weight-bold">{preDocInfo.registerDate}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">تحویل دهنده : </span>
                        <span className="font-weight-bold">
                          {preDocInfo.senderName === null ? '-' : preDocInfo.senderName}
                        </span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">تحویل گیرنده : </span>
                        <span className="font-weight-bold">
                          {preDocInfo.receiverName === null ? '-' : preDocInfo.receiverName}
                        </span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">تاریخ دستی سند : </span>
                        <span className="font-weight-bold">{preDocInfo.manualRegisterDate}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">نام تامین کننده : </span>
                        <span className="font-weight-bold">{preDocInfo.providerName}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">تاریخ فاکتور طرف : </span>
                        <span className="font-weight-bold">{preDocInfo.refFactorDate}</span>
                      </div>
                      <div className="col-auto my-1">
                        <span className="">توضیحات : </span>
                        <span className="font-weight-bold">{preDocInfo.description}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.showTable && (
                <div className="col-12 mt-2">
                  {this.state.detailEntities.length > 0 && (
                    <div className="card">
                      <div className="card-body">
                        <table className="table table-sm table-bordered">
                          <thead className="">
                            <tr>
                              <th className="font-weight-bold align-middle text-center">ردیف</th>
                              <th className="font-weight-bold align-middle text-center">کد محصول</th>
                              <th className="font-weight-bold align-middle text-center">بارکد محصول</th>
                              <th className="font-weight-bold align-middle text-center">نام محصول</th>
                              <th className="font-weight-bold align-middle text-center">تامین کننده</th>
                              <th className="font-weight-bold align-middle text-center">تعداد در پیش سند</th>
                              <th className="font-weight-bold align-middle text-center">مقدار در سفارش</th>
                              <th className="font-weight-bold align-middle text-center">انتخاب شده</th>
                              <th>#</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.detailEntities.map((item, index) => (
                              <>
                                <tr>
                                  <td>{index + 1}</td>
                                  <td className="text-center">{item.articleId}</td>
                                  <td className="text-center">{item.productCode}</td>
                                  <td>
                                    <a
                                      target="_blank"
                                      className="text-decoration-none"
                                      href={productShop({articleId: item.articleId})}
                                    >
                                      {item.productName}
                                    </a>
                                  </td>
                                  <td className="text-center">{item.providerName}</td>
                                  <td className="text-center">{item.quantity}</td>
                                  <td className="text-center">{item.sumQuantity}</td>
                                  <td className="text-center">
                                    <Checkbox
                                      checked={item.selected}
                                      onChange={() => this.changeSelectFromParrent(item)}
                                      indeterminate={item.indeterminate}
                                    />

                                    {item.selectedProductCount === 0 && item.selectedProductCount !== item.quantity && (
                                      <span className="font-weight-bold mx-2 text-danger">
                                        {item.selectedProductCount + ' مورد انتخاب شده '}
                                      </span>
                                    )}
                                    {item.selectedProductCount !== 0 && item.selectedProductCount !== item.quantity && (
                                      <span className="font-weight-bold mx-2 text-dark">
                                        {item.selectedProductCount + ' مورد انتخاب شده '}
                                      </span>
                                    )}
                                    {item.selectedProductCount === item.quantity && (
                                      <span className="font-weight-bold mx-2 text-success">
                                        {item.selectedProductCount + ' مورد انتخاب شده '}
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.detailsProduct && item.detailsProduct.length > 0 ? (
                                      <button
                                        className="border-0 bg-transparent"
                                        onClick={() => this.toggleExpand(item)}
                                      >
                                        {item.expanded ? (
                                          <i className="fas fa-caret-up" />
                                        ) : (
                                          <i className="fas fa-caret-down" />
                                        )}
                                      </button>
                                    ) : null}
                                  </td>
                                </tr>
                                {item.expanded ? (
                                  <tr className="bg-light">
                                    <td colSpan={9} className="p-3">
                                      <table className="table table-sm mb-0 table-bordered">
                                        <tr className="">
                                          <th>ردیف</th>
                                          <th>شناسه سفارش</th>
                                          <th>مقدار در سفارش</th>
                                          <th />
                                        </tr>
                                        {item.detailsProduct &&
                                          item.detailsProduct.map((ch, num) => (
                                            <tr>
                                              <td>{num + 1}</td>
                                              <td>
                                                <a
                                                  target="_blank"
                                                  style={{color: 'blue'}}
                                                  className="btn-link"
                                                  href={orderInfo({orderId: ch.orderId})}
                                                >
                                                  {ch.orderId}
                                                </a>
                                              </td>
                                              {/* <td>{ch.packageQuantity}</td> */}
                                              <td>{ch.quantity}</td>
                                              <td className="text-center">
                                                <Checkbox
                                                  checked={ch.selected}
                                                  onChange={() => this.changeItemFromChild(ch, item)}
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                      </table>
                                    </td>
                                  </tr>
                                ) : null}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer">
                        <button
                          className="btn btn-primary btn-sm"
                          disabled={!this.checkDisableButton()}
                          onClick={this.checkFields}
                        >
                          ثبت نهایی سند
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.confirmation} toggle={() => this.setState({confirmation: false})} size="sm">
          <ModalBody>
            <div className="text-center">
              <Loader show={this.state.loading} />
              <h5 className="font-weight-bold text-dark">آیا از ثبت سند مطمئن هستید؟؟</h5>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.createRecord}>
              ثبت سند
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({confirmation: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal size={'lg'} isOpen={this.state.modalShowUnmatch} toggle={() => this.setState({modalShowUnmatch: false})}>
          <ModalHeader toggle={() => this.setState({modalShowUnmatch: false})}>لیست مغایرت ها</ModalHeader>
          <ModalBody>
            <p className="titleSm">{this.state.textUnMatch}</p>
            {this.state.incompatibleRemainProducts.length > 0 && (
              <div className="">
                <p className="text-danger">لیست مغایرت موجودی انبار</p>
                <table className="table table-bordered table-sm">
                  <tbody>
                    <tr className="bg-light">
                      <th className="font-weight-bold">ردیف</th>
                      <th className="font-weight-bold">نام محصول</th>
                      <th className="font-weight-bold">کد محصول</th>
                      <th className="font-weight-bold">تعداد درخواست شده</th>
                      <th className="font-weight-bold">تعداد موجودی</th>
                    </tr>
                    {this.state.incompatibleRemainProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a target="_blank" style={{color: 'blue'}} href={productShop({articleId: product.articleId})}>
                            {product.title}
                          </a>
                        </td>
                        <td>{product.articleId}</td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.requestedQuantity}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {product.remainQuantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalShowUnmatch: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
